// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2742":"c0806155","4553":"f8d76711"}[chunkId] + ".js";
};